import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lestari_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});

export const apiErr = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string" && d) return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join("; ");
  if (!e?.response) return "Could not reach the server — please check your connection and try again";
  return `${fallback} (HTTP ${e.response.status}) — please try again`;
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("lestari_token") && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("lestari_token");
      localStorage.removeItem("lestari_user");
      window.location.href = "/welcome";
    }
    return Promise.reject(err);
  }
);
